import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@components/ui/SegmentedControl/SegmentedControl';
import type { WorkPlanControls } from './useWorkPlan';
import { PLAN_GROUPINGS, type PlanGroupBy } from './workPlanModel';
import styles from './workPlanToolbar.module.css';

export interface IWorkPlanToolbarProps {
  controls: WorkPlanControls;
  /** The window's one-line summary, on the right. */
  children: ReactNode;
}

/**
 * Group by, and the window's summary. The dates — and the window's length —
 * are the page's date picker in the header; a grouping change re-lays the grid
 * at transition priority.
 */
export function WorkPlanToolbar({ controls, children }: IWorkPlanToolbarProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.toolbar}>
      <div className={styles.grouping}>
        <span className={styles.groupLabel}>{t('activities.workPlan.groupBy')}</span>
        <SegmentedControl<PlanGroupBy>
          variant="joined"
          value={controls.groupBy}
          onChange={controls.setGroupBy}
          ariaLabel={t('activities.workPlan.groupBy')}
          options={PLAN_GROUPINGS.map((groupBy) => ({ id: groupBy, label: t(`activities.workPlan.group.${groupBy}`) }))}
        />
      </div>
      {children}
    </div>
  );
}
